/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPostBannerReqBodyDto
 */
export interface AdminPostBannerReqBodyDto {
    /**
     * 링크
     * @type {string}
     * @memberof AdminPostBannerReqBodyDto
     */
    'link'?: string;
    /**
     * 링크 타입
     * @type {string}
     * @memberof AdminPostBannerReqBodyDto
     */
    'linkType'?: AdminPostBannerReqBodyDtoLinkTypeEnum;
    /**
     * 제목
     * @type {string}
     * @memberof AdminPostBannerReqBodyDto
     */
    'title': string;
    /**
     * 부제목
     * @type {string}
     * @memberof AdminPostBannerReqBodyDto
     */
    'subtitle': string;
    /**
     * 이미지
     * @type {string}
     * @memberof AdminPostBannerReqBodyDto
     */
    'image': string;
}

export const AdminPostBannerReqBodyDtoLinkTypeEnum = {
    Self: 'self',
    Blank: 'blank'
} as const;

export type AdminPostBannerReqBodyDtoLinkTypeEnum = typeof AdminPostBannerReqBodyDtoLinkTypeEnum[keyof typeof AdminPostBannerReqBodyDtoLinkTypeEnum];


